"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationRegex = void 0;
exports.ValidationRegex = {
    normalizeAlphaNumericInput: /[^0-9a-z]+/i,
    spaceOrDash: /[\s-]/g,
    /*
    Allows for alphanumeric characters in a license plate number,
    with an optional space or hyphen in the middle, and an optional space or hyphen at the end.
    The maximum length of the string is 10 characters.
    */
    finalLicensePlateRegex: /^(?=.{0,10}$)[a-z0-9]+(?:[\s-][a-z0-9]+)?[\s-]?$/i
};
